import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

import { AGENT_HELP_ADDRESS } from "@consts/index";
import { PolicyDetailsContentProps } from "../../types";
import { DocumentsList } from "./DocumentsLists";
import { DocumentsUpload } from "./DocumentsUpload";

export function Documents({ policy, loading }: PolicyDetailsContentProps) {
  if (!policy && loading) {
    return <Skeleton height={114} variant="rounded" />;
  }

  if (policy && !policy.documents?.length) {
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          Policy was found but it has no documents assigned. Please contact us
          via email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <DocumentsUpload policy={policy} />
      <DocumentsList policy={policy} />
    </>
  );
}
